import { Maybe, SanityRoleBasedAccessControl } from '../../graphql/gatsby'
import { UserCategory } from '../../utils/userClaims'

export enum SanityUserRole {
  Anonymous = 'ANONYMOUS',
  Authenticated = 'AUTHENTICATED',
  CategoryEmployee = 'CAT_EMPLOYEE',
  CategoryOtherProfessional = 'CAT_OTHER_PROFESSIONAL',
  CategoryPatient = 'CAT_PATIENT',
  CategoryPractitioner = 'CAT_PRACTITIONER',
  CategoryPractitionerNonPharmacist = 'CAT_PRACTITIONER_NON_PHARMACIST',
  ScopeReadPharmacyContent = 'SCOPE_READ_PHARMACY_CONTENT',
}

export const sanityUserRoles = Object.values(SanityUserRole)

export function isSanityUserRole(value: string | undefined | null): value is SanityUserRole {
  return !!value && sanityUserRoles.includes(value as SanityUserRole)
}

const userCategoryToRoleMap: Record<UserCategory, SanityUserRole> = {
  employee: SanityUserRole.CategoryEmployee,
  other_professional: SanityUserRole.CategoryOtherProfessional,
  patient: SanityUserRole.CategoryPatient,
  practitioner: SanityUserRole.CategoryPractitioner,
}

export function userRoleFromCategory(value: UserCategory): SanityUserRole {
  return userCategoryToRoleMap[value]
}

type RoleBasedAccessControl =
  | Maybe<Pick<SanityRoleBasedAccessControl, 'enabled' | 'roles'>>
  | undefined

export function hasRoleAccess(
  roleBasedAccessControl: RoleBasedAccessControl,
  userRoles: ReadonlyArray<SanityUserRole>,
): boolean {
  if (!roleBasedAccessControl || roleBasedAccessControl.enabled !== true) {
    return true
  }
  return (roleBasedAccessControl.roles || [])
    .filter(isSanityUserRole)
    .some((role) => userRoles.includes(role))
}

// crawlers never log in, so they see what anonymous visitors see
export function isClosedToAnonymous(roleBasedAccessControl: RoleBasedAccessControl): boolean {
  return !hasRoleAccess(roleBasedAccessControl, [SanityUserRole.Anonymous])
}
